<template>
  <div class="customer-list clearfix">
    <Search @getHeight="getHeight"
            @saveSet="saveSet"
            width="350px"
            ref="Search"
            :isquery="true"
            :showAdd="true"
            :delPara="delPara"
            :showDel="activeTab === '我的黑名单'?true:false"
            :showSort="false"
            delName="移除"
            :advancedQuery="false"
            :tableConfig="tableConfig"
            :tableName="tableName"
            @add="addBlacklist"
            searchName="getPageData">
      <template v-slot:left>
        <el-col :lg="24"
                :md="24"
                :sm="24"
                :xs="24">
          <el-form-item label="关键字"
                        prop="keyWord">
            <el-input @keyup.enter.native="getPageData()"
                      v-model="searchForm.keyWord"
                      clearable
                      placeholder="请输入关键字查询"></el-input>
          </el-form-item>
        </el-col>
      </template>
    </Search>
    <div class="blacklist-table-list fr page">
      <el-tabs v-model="activeTab"
               type="card"
               @tab-click="getBlacklist()">
        <el-tab-pane label="我的黑名单"
                     name="我的黑名单"></el-tab-pane>
        <el-tab-pane label="公共黑名单"
                     name="公共黑名单"></el-tab-pane>
      </el-tabs>
      <MyTable @sortChange="sortChange"
               @selectionChange="selectionChange"
               tableType="selection"
               :tableData="tableData"
               :tableConfig="tableConfig"
               :height="tableHeight"
               :indexFlag="true">
        <template v-slot:index="slotData">
          {{
            ($refs.pagination.currentPage - 1) * $refs.pagination.pageSize +
            slotData.scope.$index +
            1
          }}
        </template>
        <template v-slot:time="slotData">
          {{
            slotData.scope.row.creationTime &&
            slotData.scope.row.creationTime.slice(0, 10)
          }}
        </template>

        <template v-slot:entryDate="slotData">
          {{
            slotData.scope.row.entryDate &&
            slotData.scope.row.entryDate.slice(0, 10)
          }}
        </template>
        <template v-slot:cname="slotData">
          {{ slotData.scope.row.cname }}
        </template>
        <template v-slot:operation="slotData">
          <el-button @click.stop="reason(slotData.scope.row)"
                     size="small"
                     icon="el-icon-view"
                     :loading="submitLoading"
                     v-if="verifyPermission('Select') && activeTab == '我的黑名单'">查看原因</el-button>
        </template>
      </MyTable>
      <Pagination class="PagPosition"
                  :total="total"
                  @getNewData="getPageData"
                  ref="pagination" />
    </div>

  </div>
</template>

<script>

import { verifyPermissionMinix, GetUnlimitedQRCodeMinix } from "@/utils/mixin";
import Search from "@/components/Search";
import MyTable from "@/components/Table";

export default {
  components: {
    MyTable,
    Search,

  },
  mixins: [verifyPermissionMinix, GetUnlimitedQRCodeMinix],

  data () {
    return {
      tableName: "blacklist",
      flag: true,
      activeTab: "我的黑名单",
      form: {},
      delPara: {
        data: "",
        controller: "BlackListInfo",
        action: "Delete",
        callback: "getPageData",
      },
      totalCount: 0,
      onerow: "",
      companyList: [],
      tableConfig: [
        {
          field: "creationTime",
          label: "创建时间",
          slotName: "time",
          minWidth: 80,
          align: "center",
          width: 150,
          flag: true,
        },
        {
          field: "name",
          label: "姓名",
          align: "center",
          flag: true,
          minWidth: 150,
        },
        {
          field: "gender",
          label: "性别",
          align: "center",
          width: 80,
          flag: true,
        },
        {
          field: "phoneNumber",
          label: "手机号码",
          align: "center",
          width: 130,
          flag: true,
        },

        {
          field: "identityCard",
          label: "身份证号",
          align: "center",
          width: 180,
          flag: true,
        },
        {
          field: "permanentResidence",
          label: "户口所在地",
          align: "center",
          width: 180,
          flag: true,
        },
        {
          field: "educationalLevel",
          label: "文化程度",
          align: "center",
          width: 130,
          flag: true,
        },

        {
          label: "基本操作",
          slotName: "operation",
          width: 160,
          align: "center",
          flag: true,
          fixed: "right",
        },
      ],
      submitLoading: false,
      total: 0,
      loading: false,
      tableData: [],
      searchForm: {},
      row: "",
      customerIds: [],
      operation: "",
      tableHeight: "",
    };
  },
  mounted () {
    this.getPageData();
    let detail = JSON.parse(window.localStorage.getItem("userInfo"));
    let Companydetail = JSON.parse(
      window.localStorage.getItem("CompanyDetail")
    );
    this.userAutoIntId = detail.autoIntId;
    this.CompanyAutoIntId = Companydetail.autoIntId;
    if (localStorage.getItem(this.tableName)) {
      this.tableConfig = JSON.parse(localStorage.getItem(this.tableName));
      this.sortType = this.tableConfig.pop();
      this.tableConfig.forEach((element) => {
        if (element.sortable) {
          element.sortable = this.sortType;
        }
      });
    }
  },
  methods: {
    //提示去员工管理添加黑名单
    addBlacklist () {
      this.$confirm('确定去员工管理添加黑名单吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$router.push({
          path: '/personnelList',
        });
      }).catch(() => {

      });
    },
    //获取黑名单列表
    getBlacklist () {
      this.getPageData();
    },
    //查看原因
    reason (row) {
      this.$alert(row.reason, '黑名单原因', {
        confirmButtonText: '确定',
        callback: action => {

        }
      });
    },
    sortChange () {

    },
    // 列的显示与隐藏
    saveSet (checkList, type) {
      if (checkList) {
        this.tableConfig = JSON.parse(JSON.stringify(checkList));
      }
      this.sortType = type;
      this.tableConfig.forEach((element) => {
        if (element.sortable) {
          element.sortable = type;
        }
      });
    },
    getHeight (height) {
      this.tableHeight = height;
    },
    //重置表单
    resetForm () {
      this.form = {};
      this.$refs.form.clearValidate();
    },
    clear () {
      console.log(0);
      this.searchForm.isCooperation = undefined;
    },
    //排序
    sortCustomer () {
      let arr = [];
      let obj = {};
      this.tableData.forEach((element) => {
        if (element.add == "1") {
          obj.id = element.id;
          obj.sort = element.sort;
          arr.push(obj);
          obj = {};
        }
      });
      this.$api.customer.sort(arr).then((res) => {
        if (res.error === false) {
          this.getPageData();
        }
      });
    },
    //获取数据
    getPageData () {

      this.loading = true;
      let sendData = {};
      sendData = {
        pageIndex: this.$refs.pagination.currentPage,
        pageSize: this.$refs.pagination.pageSize,
        wheres: [
          {
            name: "keyword",
            value: this.searchForm.keyWord,
            expressionType: 'Like',
          },

        ],
      };
      this.$api.BlackListInfo[this.activeTab == '我的黑名单' ? 'PageData' : 'PublicPageData'](sendData).then((res) => {
        this.loading = false;
        if (!res.error) {
          this.tableData = res.data.data;
          this.total = res.data.count;
        }
      });
    },

    selectionChange (selection) {
      this.oneId = [];
      this.customerIds = selection.map((v) => {
        return v.id;
      });
      this.delPara.data = selection.map((v) => {
        return v.id;
      });
    },
  },
};
</script>
<style lang="less" >
.customer-list {
  .upload-demo {
    .el-upload {
      width: 100% !important;
    }
    .el-upload-dragger {
      width: 100% !important;
    }
  }
}
</style>
<style lang="less">
.blacklist-table-list .el-tabs__header {
  margin: 0;
}
.userFlag {
  color: gray;
  font-style: italic;
}
.el-table .cell {
  white-space: pre-line;
}
.chabtn {
  margin-left: 15px;
}
.btn {
  margin-left: 15px;
}
.customer-list {
  .file,
  .table {
    width: 100%;
    .title {
      display: flex;
      align-items: center;
      .num {
        // color: rgb(26, 210, 103);
        font-size: 22px;
        margin-right: 15px;
      }
    }

    .upload-demo {
      width: 100%;
      padding: 10px 70px;
      .el-upload-dragger {
        width: 100% !important;
      }
    }
    .result {
      padding: 10px 70px;
    }
  }
  .category {
    width: 200px;
    height: calc(100vh - 155px);
    background-color: #fff;
    border-radius: 6px;
    padding: 20px;
    margin-right: 20px;
    > div {
      display: flex;
      align-items: center;
      padding-bottom: 10px;
      border-bottom: 1px solid #ddd;
      font-weight: bold;
      font-size: 15px;
      img {
        width: 16px;
        margin-right: 5px;
      }
    }
    li {
      margin-top: 12px;
      cursor: pointer;
      &:hover {
        color: var(--theme-black);
        text-decoration: underline;
      }
    }
    .tab-active {
      color: #87481f !important;
      text-decoration: underline !important;
    }
  }
  .customer-table-list {
    width: calc(100%);
    height: calc(100vh - 140px);
  }
}
</style>
